import { createClient } from '@supabase/supabase-js';

const supabaseUrl = "https://fsfjrplooiozffzzrymk.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZzZmpycGxvb2lvemZmenpyeW1rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE2Mjk3MTQsImV4cCI6MjA1NzIwNTcxNH0.pffZenfEVxvKPZWmV8TRWZrSXY7Qd7s8B_2cTDbtf60";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: { persistSession: true, autoRefreshToken: true },
});
